<template>
  <footer>
    <div class="wrapper footer-wrapper">
      <div class="footer-branding">
        <div class="logo"><img :src="require('../assets/images/footer-branding.svg')"/></div>
      </div>
      <div class="footer-text">
        <div>
          <p>&copy; Gabiano Holding All Rights Reserved<br/>
            Viale Europa Unita, 10 - 10040 Volvera (TO)<br/>
            PIVA 10905030010</p>
          <ul class="links">
            <li>
              <router-link :to="{ name: 'privacy-policy', params: { nodetitle : 'Privacy policy' }}">Privacy policy
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'cookie-policy', params: { nodetitle : 'Cookie policy' }}">Cookie policy
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'company-data', params: { nodetitle : 'Dati societari' }}">Dati societari
              </router-link>
            </li>
          </ul>
        </div>
        <div>
          <p>Gabiano sostiene Fondazione Millesoli<br/>e Save the Children</p>

          <ul class="loghi">
            <li class="fondazione-millesoli"><img :src="require('../assets/images/fondazione-millesoli.svg')"/></li>
            <li class="save-the-children"><img :src="require('../assets/images/save-the-children.svg')"/></li>
          </ul>
        </div>
        <!--         <div class="social">
                  <ul class="loghi">
                    <li class="linkedin"><a href="https://www.linkedin.com/company/gabiano-telecomunicazioni-srl/" target="_blank" class="linkedin">linkedin</a></li>
                  </ul>
                </div> -->
      </div>
    </div>
  </footer>
</template>

<script>

  export default {
    name: 'Footer'
  }
</script>
